module.exports = __webpack_public_path__ + "img/p6.e4f5e084.png";